import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./AddDepartment.css";
import Header from "../../../../../../header/header";
import Navvbar from "../../../../../../header/Navvbar";

/* ===== Shared-style Settings Sidebar (isi file ke andar) ===== */
const SettingsSidebar = () => (
  <div className="my-sidebar">
    <h2 className="my-sidebar-title">Settings</h2>
    <div className="my-sidebar-links">
      <Link to="/lab-details" className="my-sidebar-link">Lab Details</Link>
      <Link
        to="#"
        onClick={(e) => e.preventDefault()}
        className="my-sidebar-link my-sidebar-disabled"
      >
        Store
      </Link>
      <Link to="/users" className="my-sidebar-link">Users</Link>
      <Link
        to="#"
        onClick={(e) => e.preventDefault()}
        className="my-sidebar-link my-sidebar-disabled"
      >
        Permission Groups
      </Link>
      <Link to="/accountTable" className="my-sidebar-link">Accounts</Link>
      <Link to="/financeOwerview" className="my-sidebar-link">Finances</Link>
      <Link to="/owersetting" className="my-sidebar-link">Case Settings</Link>
    </div>
  </div>
);

const AddDepartment = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    dailyLimit: "0",
    customId: "",
  });

  const departmentsOrder = [
    "CROWN AND BRIDGE",
    "ORTHODONTIC",
    "IMPLANTS",
    "All Departments",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (!formData.name.trim()) {
      alert("Department name is required!");
      return;
    }
    console.log("Adding Data:", formData);
    alert("Department added successfully!");
    navigate(-1);
  };

  return (
    <div className="ad-layout">
      <div className="ad-header-container">
        <Header />
        <Navvbar />
      </div>

      <div className="ad-main-wrapper">
        <div className="ad-row">
          {/* ===== SIDEBAR ===== */}
          <div className="ad-sidebar">
            <SettingsSidebar />
          </div>

          {/* ===== CONTENT ===== */}
          <div className="ad-content ad-content-only">
            <h2 className="ad-title">Add Department</h2>

            <div className="ad-section">
              <h5 className="ad-section-title ad-section-title-line">
                Department Details
              </h5>
              <div className="ad-form-box">
                <div className="ad-form-row">
                  <label className="ad-form-label">
                    Name <span className="ad-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="ad-form-input"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="ad-form-row">
                  <label className="ad-form-label">Daily Limit</label>
                  <div className="ad-daily-limit-group">
                    <input
                      type="number"
                      name="dailyLimit"
                      className="ad-form-input ad-limit-input"
                      value={formData.dailyLimit}
                      onChange={handleChange}
                    />
                    <span className="ad-limit-text">Task Blocks</span>
                  </div>
                </div>

                <div className="ad-form-row">
                  <label className="ad-form-label">Custom ID</label>
                  <input
                    type="text"
                    name="customId"
                    className="ad-form-input"
                    placeholder="Custom Identifier"
                    value={formData.customId}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="ad-section" style={{ marginTop: "20px" }}>
              <h5 className="ad-section-title">Departments Order</h5>
              <div className="ad-order-list">
                {departmentsOrder.map((dept, index) => (
                  <div key={index} className="ad-order-item">
                    {dept}
                  </div>
                ))}
              </div>
            </div>

            <div className="ad-actions">
              <button className="ad-btn" onClick={handleSave}>
                <span className="ad-save-icon">💾</span> Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDepartment;